var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContainers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 68,
    viewBox: "0 0 110 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8131_5917)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8131_5917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.1591 33H40V68H75.1591V33Z",
    fill: "#D87706"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 33H50.8408V68H86V33Z",
    fill: "#F49D0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8408 33.002L40 39.5441V33.002H50.8408Z",
    fill: "#B35309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.61 53.4413H43.9805L44.5537 51.8589L43.9805 50.147H57.4828L56.6552 51.9271L57.61 53.4413Z",
    fill: "#FCE589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7947 50.144V53.4412H43.9795L44.5526 51.8589L43.9795 50.1469L50.7947 50.144Z",
    fill: "#B35309"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_8131_5917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.6369 47H76V68H96.6369V47Z",
    fill: "#D87706"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 47H82.363V68H103V47Z",
    fill: "#F49D0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3631 47.0012L76 50.9264V47.0012H82.3631Z",
    fill: "#B35309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3368 59.2648H78.3369L78.6734 58.3154L78.3369 57.2882H86.2622L85.7764 58.3563L86.3368 59.2648Z",
    fill: "#FCE589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3362 57.2864V59.2647H78.3359L78.6723 58.3153L78.3359 57.2882L82.3362 57.2864Z",
    fill: "#B35309"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_8131_5917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.1591 33H0V68H35.1591V33Z",
    fill: "#D87706"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 33H10.8408V68H46V33Z",
    fill: "#F49D0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8408 33.002L0 39.5441V33.002H10.8408Z",
    fill: "#B35309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.61 53.4413H3.98047L4.55373 51.8589L3.98047 50.147H17.4828L16.6552 51.9271L17.61 53.4413Z",
    fill: "#FCE589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7947 50.144V53.4412H3.97949L4.55263 51.8589L3.97949 50.1469L10.7947 50.144Z",
    fill: "#B35309"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_8131_5917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8611 0H12.9951V33H45.8611V0Z",
    fill: "#64748A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9951 0H23.1292V33H55.9951V0Z",
    fill: "#9BA2AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5012 9.30257H17.6924L18.147 8.03451L17.6924 6.66541H28.4015L27.7447 8.08557L28.5012 9.30257Z",
    fill: "#E4E6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0958 6.66541V9.30257H17.6914L18.146 8.03451L17.6914 6.66541H23.0958Z",
    fill: "#9BA2AE"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_8131_5917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.994 55H93V68H105.994V55Z",
    fill: "#64748A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 55H97.0068V68H110V55Z",
    fill: "#9BA2AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1297 58.6641H94.8564L95.0362 58.1648L94.8564 57.6257H99.0903L98.8306 58.1849L99.1297 58.6641Z",
    fill: "#E4E6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9931 57.6257V58.6641H94.8564L95.0362 58.1648L94.8564 57.6257H96.9931Z",
    fill: "#9BA2AE"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_8131_5917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.28 40H29V68H57.28V40Z",
    fill: "#64748A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9998 40H37.7197V68H65.9998V40Z",
    fill: "#9BA2AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3414 47.8932H33.0408L33.4319 46.8172L33.0408 45.6556H42.2556L41.6905 46.8606L42.3414 47.8932Z",
    fill: "#E4E6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6903 45.6556V47.8932H33.04L33.4312 46.8172L33.04 45.6556H37.6903Z",
    fill: "#9BA2AE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8131_5917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 68,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8131_5917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 35,
    fill: "white",
    transform: "translate(40 33)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_8131_5917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 21,
    fill: "white",
    transform: "translate(76 47)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_8131_5917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 35,
    fill: "white",
    transform: "translate(0 33)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_8131_5917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 33,
    fill: "white",
    transform: "translate(12.9951)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_8131_5917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.0004,
    height: 13,
    fill: "white",
    transform: "translate(93 55)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_8131_5917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 28,
    fill: "white",
    transform: "translate(29 40)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainers);
export default __webpack_public_path__ + "static/media/containers.5508129c4e9a90516f8d9c945cd5fbde.svg";
export { ForwardRef as ReactComponent };